import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext/AuthContext';

// Portal catch-all target: send unauthenticated users to login and
// authenticated users to their role-appropriate dashboard, so no undefined or
// mistyped /portal/* URL ever renders a blank page.
const PortalRedirect = () => {
	const { currentUser, userRole } = useAuth();

	if (!currentUser) {
		return <Navigate to='/portal/login' replace />;
	}
	if (userRole === 'employee' || userRole === 'admin') {
		return <Navigate to='/portal/work' replace />;
	}
	return <Navigate to='/portal/customer' replace />;
};

export default PortalRedirect;
